import script from "./CommitterStatDetailTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CommitterStatDetailTable.vue?vue&type=script&setup=true&lang=js"

import "./CommitterStatDetailTable.vue?vue&type=style&index=0&id=6c36c2a3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c36c2a3"]])

export default __exports__